import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { type Role } from "../types/user";
import { getAuthHeader, serverUrl } from ".";

export const useLogin = () => {
  return useMutation({
    mutationFn: async ({
      role,
      id,
      password,
    }: {
      role: Role;
      id: string;
      password: string;
    }) => {
      const response = await axios.post(`${serverUrl}/${role}/login/`, {
        id,
        password,
      });

      return response.data;
    },
  });
};

export const useResetPasswordAfterLogin = ({ role }: { role: Role }) => {
  return useMutation({
    mutationFn: async (data: any) => {
      const response = await axios.patch(
        `${serverUrl}/${role}/reset-password`,
        data,
        getAuthHeader()
      );
      return response.data;
    },
  });
};

export const useLostPassword = ({ role }: { role: Role }) => {
  return useMutation({
    mutationFn: async (data: any) => {
      const response = await axios.post(
        `${serverUrl}/${role}/lost-password`,
        data
      );
      return response.data;
    },
  });
};
